<template>
  <div class="row">
    <div class="col-md-6">
      <div class="card mb-3">
        <div class="card-body">
          <div class="small text-uppercase mb-2 text-muted">
            <i class="fa fa-phone mr-1 ml-1"></i>
            Call Center Line
            <span class="ml-2 badge badge-success text-uppercase">
              Public
            </span>
          </div>
          <div class="h3 pb-3">
            {{ callCenter.formatted_enqueue_phone }}
          </div>
        </div>
        <div class="card-footer">
          <div class="small">
            This number is what people call to get in the queue.
            You should publish this number to leverage
            your call center.
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <div class="small text-uppercase mb-2 text-muted">
            <i class="fa fa-lock mr-1 ml-1"></i>
            Queue Line
            <span class="ml-2 badge badge-light-gray text-uppercase">
              Private
            </span>
          </div>
          <div class="h3 pb-3">
            {{ callCenter.formatted_queue_phone }}
          </div>
        </div>
        <div class="card-footer">
          <div class="small">
            If a call is in the queue and no one is picking up,
            you can dial this number to answer the call. You
            should keep this number private.
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <call-center-member
        v-for="member in callCenter.members"
        v-bind:key="member.id"
        :call-center="callCenter"
        :member="member"
      ></call-center-member>
    </div>
  </div>
</template>

<script>
import { getCallCenter } from '@/api'
import CallCenterMember from '@/components/CallCenterMember'

export default {
  components: {
    CallCenterMember
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      callCenter: {
        formatted_queue_phone: null,
        formatted_enqueue_phone: null,
        members: []
      }
    }
  },
  async mounted () {
    try {
      const response = await getCallCenter(this.id)
      this.callCenter = response.data
    } catch (e) {
      //
    }
  }
}
</script>